<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <div class="basic-title"><em>学生导入</em></div>
          <el-row>
            <el-col
              :span="12">
              <div
                class="grid-content bg-purple"
                style="text-align: center">
                <jm-upload
                  :on-success="uploadBack"
                  :on-progress="loading"
                  class="upload-demo"
                  v-loading="exporting"
                  action="/newfib.php/index/student/student_leadingIn">
                  <el-button
                    size="big" type="primary">学生导入</el-button>
                </jm-upload>
              </div>
            </el-col>
            <el-col
              :span="12">
              <div class="grid-content bg-purple"
                   style="text-align: center">
                <a href="/frontend/static/昆仑学生资源导入模板表.xlsx" download="">
                  <el-button size="big" type="primary">模板下载</el-button>
                </a>
              </div>
            </el-col>
          </el-row>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal">
            <el-menu-item
              index="2"
              @click="all_file">全部</el-menu-item>
            <el-menu-item
              index="1"
              @click="success_file">成功</el-menu-item>
            <el-menu-item
              index="3"
              @click="no_success">未成功</el-menu-item>
          </el-menu>
          <jm-tableList
            v-if="tableList_status"
            :url="file_url"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList"/>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  #main-content{
    margin-left: 0;
  }
</style>
<script>
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      activeIndex: '2',
      refresh: false,
      searchData: {
        status: '',
        import_count: 0,
      },
      selectVal: [],
      file_url: '',
      tableList_status: false,
      exporting: false,
    };
  },
  components: {
    'jm-tableList': tableList,
    jmDictSelect,
  },
  methods: {
    uploadBack(file) {
      console.log(file);
      this.exporting = false;
      if (file === '请上传模板类型文件') {
        this.$message.error('请上传模板类型文件');
      } else {
        this.tableList_status = true;
        this.file_url = '/index/student/show_excel_data';
        this.searchData.import_count = file;
        this.refresh = true;
      }
    },
    loading() {
      this.exporting = true;
    },
    all_file() {
      this.searchData.status = 0;
      this.refresh = true;
    },
    success_file() {
      this.searchData.status = 1;
      this.refresh = true;
    },
    no_success() {
      this.searchData.status = 2;
      this.refresh = true;
    },
    templateDownload() {
      this.$http._post({
        url: '/index/student/templateExport',
      }).then(({ data }) => {
        let downloadName = '学生资源导入模板表.xlsx';
        this.$http._download({
          filename: data,
          download: downloadName
        });
      });
    }
  }
};
</script>
